import React from "react";
import SVG from "react-inlinesvg";
import DiffMatchPatchViewer from "../Reviser/DiffMatchPatchViewer";

/**
 * @param {{
 *   string1: string;
 *   string2: string;
 *   cleanUp?: string;
 *   diffUnit?: "character" | "word";
 *   showApplyControl?: boolean;
 *   onApplyClick?: () => void;
 * }} props
 */
const InlineDiffViewer = ({
  string1,
  string2,
  cleanUp = "semantic",
  diffUnit = "character",
  showApplyControl = false,
  onApplyClick,
}) => {
  const containerStyle = {
    width: "100%",
  };

  const diffStyle = {
    display: "inline-block",
    whiteSpace: "pre-wrap",
    wordBreak: "normal",
    overflowWrap: "break-word",
    width: "100%",
  };

  const controlsRowStyle = { display: "flex", alignItems: "center", marginTop: "0.625rem", width: "100%" };

  const applyButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: 500,
    userSelect: "none",
  };

  const handleApply = (event) => {
    event.stopPropagation();
    if (onApplyClick) onApplyClick();
  };

  const handleApplyKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleApply(event);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={diffStyle}>
        <DiffMatchPatchViewer
          string1={string1}
          string2={string2}
          cleanUp={cleanUp}
          diffUnit={diffUnit}
          inline={true}
          showPilcrows={false}
        />
      </div>
      {showApplyControl && (
        <div style={controlsRowStyle}>
          <div
            role="button"
            tabIndex={0}
            aria-label="Apply suggestion"
            style={applyButtonStyle}
            onClick={handleApply}
            onKeyDown={handleApplyKeyDown}
          >
            <SVG
              src="/assets/arrow.backward.circle.svg"
              aria-hidden={true}
              width={16}
              height={16}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default InlineDiffViewer;
